import { makeStyles } from '@material-ui/styles'
import React from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import type Theme from 'core/themes/model'

interface CapacityCardProps {
  title: string
  count?: number
  onSeeAll?: () => void
  children: React.ReactNode
  testId?: string
}

const CapacityCard = ({ title, count, onSeeAll, children, testId }: CapacityCardProps) => {
  const classes = useStyles()

  return (
    <div className={classes.cardContainer} data-testid={testId}>
      <div className={classes.cardContent}>
        <div className={classes.rightContent}>
          <Text variant="subtitle2">
            {title}
            {count !== undefined && ` (${count})`}
          </Text>
          {onSeeAll && (
            <span className={classes.seeAll} onClick={onSeeAll} data-testid={`${testId}-see-all`}>
              <Text variant="caption1">See All</Text>
              <FontAwesomeIcon regular size="md" className={classes.icon}>
                chevron-right
              </FontAwesomeIcon>
            </span>
          )}
        </div>
        <Text variant="body2" className={classes.content}>
          {children}
        </Text>
      </div>
    </div>
  )
}

export default CapacityCard

const useStyles = makeStyles((theme: Theme) => ({
  cardContainer: {
    backgroundColor: theme.components.card.background,
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRight: '1px solid #e6e6ea',
    minHeight: '6.25rem',
  },
  cardContent: {
    display: 'grid',
    alignContent: 'center',
    marginLeft: theme.spacing(3),
    height: '100%',
    textAlign: 'start',
  },
  rightContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    marginTop: theme.spacing(1),
    display: 'flex',
  },
  seeAll: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    paddingRight: theme.spacing(1),
    cursor: 'pointer',
  },
  icon: {
    paddingLeft: theme.spacing(0.5),
    fontSize: '12px',
  },
}))
